const initialState={
    data:null,
    status:"idle",
    error:null,
}
const aboutusReducer= (state=initialState,action)=>{
    switch (action.type){
        case "SET_ABOUTUS_DATA":
            return {...state, data:action.payload};
        default:
            return state;
    }
}

export default aboutusReducer